import { ModalSectionLayout } from "./ModalSectionLayout";
import { CopyableUrlField } from "@/components/Form/CopyableUrlField";
import type { McpIdentityInfo } from "@/generated";

export function MCPIdentityPanel({ info }: { info: McpIdentityInfo }) {
  const rows: { label: string; value: string }[] = [
    { label: "Header", value: info.header_name },
    { label: "Public keys (JWKS)", value: info.jwks_url },
    { label: "Issuer (iss)", value: info.issuer },
    { label: "Audience (aud)", value: info.audience },
    { label: "Algorithm", value: info.algorithm },
    { label: "Token type (token_use)", value: info.token_use },
    {
      label: "Lifetime",
      value: `${Math.round(info.lifetime_seconds / 60)} minutes`,
    },
  ];

  return (
    <ModalSectionLayout
      title="Identity token"
      description="Every request carries a token signed by Noxus for the person chatting, with their Noxus user_id and email."
    >
      <div className="flex flex-col gap-4">
        {rows.map((row) => (
          <CopyableUrlField key={row.label} label={row.label} url={row.value} />
        ))}
      </div>
    </ModalSectionLayout>
  );
}
